import { Directive, ElementRef, Input, AfterViewInit } from "@angular/core";

@Directive({
    selector: "[appEllipsis]",
})
export class EllipsisDirective implements AfterViewInit {
    @Input() maxWidth?: string;
    @Input() lines = 1;

    constructor(private el: ElementRef<HTMLElement>) {}

    ngAfterViewInit() {
        const style = this.el.nativeElement.style;
        style.whiteSpace = "nowrap";
        style.overflow = "hidden";
        style.textOverflow = "ellipsis";

        if (this.lines === 1) {
            // Single line ellipsis
            style.whiteSpace = "nowrap";
        } else {
            // Multi-line ellipsis
            style.display = "-webkit-box";
            style.webkitBoxOrient = "vertical";
            style.webkitLineClamp = String(this.lines);
            style.whiteSpace = "normal";
        }

        if (this.maxWidth) {
            style.maxWidth = this.maxWidth;
        }
    }
}
